import React from 'react'
import ReactDOM from 'react-dom'
import { useEvent, useState } from '@/core'
import { getComponents } from './selector'
import { constant } from './constant'
import { VoeSignificationTable } from './component/voeSignificationTable'

type State = {
	tableWrapper: HTMLElement | null
}

export const SignificationTable = (() => {
	const { state, setState } = useState<State>()

	const initTable = () => {
		const { tableWrapper } = state

		if (tableWrapper === null) {
			return
		}

		const dataString = tableWrapper.getAttribute(constant.attribute.data)

		if (dataString === null) {
			return
		}

		const data = JSON.parse(dataString)

		const changeUrl = tableWrapper.getAttribute(constant.attribute.changeUrl)

		if (changeUrl === null) {
			return
		}

		let rowColor = tableWrapper.getAttribute(constant.attribute.rowColor)

		if (rowColor === '') {
			rowColor = null
		}

		let rowContentColor = tableWrapper.getAttribute(constant.attribute.rowContentColor)

		if (rowContentColor === '') {
			rowContentColor = null
		}

		let fontColor = tableWrapper.getAttribute(constant.attribute.fontColor)

		if (fontColor === '') {
			fontColor = null
		}

		let translationsString = tableWrapper.getAttribute(constant.attribute.translations)

		if (translationsString === null) {
			return
		}

		const translations = JSON.parse(translationsString)

		ReactDOM.render(
			<VoeSignificationTable
				data={data}
				changeUrl={changeUrl}
				fontColor={fontColor}
				rowColor={rowColor}
				rowContentColor={rowContentColor}
				translations={translations}
			/>,
			tableWrapper,
		)
	}

	const init = () => {
		setState(getComponents())

		initTable()
	}

	return {
		init,
	}
})()
